/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link, useParams } from "react-router-dom";
import DataLoader from "../../Component/Loader/DataLoader";
import SubscribeResource from "../../Component/Subscribe/SubscribeResource";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { loadResourcesHubData, loadSettingData } from "./Slice/resourcesHubSlice";
import PropTypes from "prop-types";

function setClass(key) {
  const class1 = 'ps-lg-0 col-lg-4';
  const class2 = 'col-lg-8';

  if (key % 4 === 0 || key % 4 === 3) {
    return class2;
  }
  else if (key % 4 === 1 || key % 4 === 2) {
    return class1;
  }
}

function Index(props) {

  const dispatch = useDispatch();
  const isAuth = useSelector((state) => state?.isAuth);
  const { resources, setting, loading } = useSelector((state) => state?.resourcesHub);

  const getFieldValidation = (field) => {
    return setting?.module_data?.find(item => item?.name === field);
  };

  const getFieldValidationChildren = (field, childName) => {
    if (getFieldValidation(field)?.children?.length > 0) {
      return getFieldValidation(field)?.children?.find(item => item?.name === childName);
    }
  };

  const { params } = useParams();
  const [title, setTitle] = useState('');
  const history = useNavigate();
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const PostResourceHub = async (e) => {
    e.preventDefault();
    if (isAuth === false) {
      setPopupMessage(
        "Thank you for browsing! Help us create a meaningful mentoring engagement for you by registering in one simple step, or login if you already have an account."
      );
      setShowPopup(true);
      history(`/login`);
    } else if (localStorage.isConfirmed === "true") {
      globalThis.location = "/post-resource-hub";
    } else {
      setPopupMessage("Please Complete Your Profile First.");
      setShowPopup(true);
      return
    }
  };

  useEffect(() => {
    // Load settings first
    dispatch(loadSettingData());

    const request = {};
    if (params) {
      request.category = params;
    } else {
      request.category = 'all-posts';
    }
    dispatch(loadResourcesHubData(request));
  }, [dispatch, params]);

  const resoucesPages = async (e, name, slug) => {
    e.preventDefault();
    history(`/resource-hub/${slug}`);
  };

  const redirectNewsletter = async (e) => {
    e.preventDefault();
    history("/newsletter");
  };

  const redirectVideos = async (e) => {
    e.preventDefault();
    history("/videos");
  };

  const resoucesDrop = [{
    'name': 'All posts',
    'slug': 'all-posts',
    'value': '0',
    'class': 'fas fa-mail-bulk',
    'key': '0'
  },
  {
    'name': 'People stories',
    'slug': 'people-stories',
    'value': '1',
    'class': 'fas fa-user-clock',
    'key': '1'
  },
  {
    'name': 'Points of view',
    'slug': 'points-of-view',
    'value': '2',
    'class': 'fas fa-street-view',
    'key': '2'
  },
  {
    'name': 'Toolkits',
    'slug': 'toolkits',
    'value': '3',
    'class': 'fas fa-toolbox',
    'key': '3'
  }
  ];

  const { slug } = useParams();

  const resource_data = resoucesDrop.find((flower) => flower?.slug === slug);
  const siteName = setting?.name?.trim() || `${resource_data?.name || ''}`;

  useEffect(() => {
    if (slug !== 'all-posts') {
      setTitle(resource_data?.name);
    }
    const title = `${siteName} | ${resource_data?.name || ''}`;

    document.title = title;

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', resource_data?.name || '');
    }
  }, [siteName, slug, resource_data?.name, setTitle]);

  const moduleRenderData = setting?.module_data
  const isSectionShow = (name) => {
    return moduleRenderData?.some((item) => item?.name === name && item?.status === "Enabled" && item?.is_default === "Yes")
  }

  const renderResourceContent = () => {
    if (loading) {
      return <DataLoader />;
    }

    if (resources?.length === 0) {
      return <div className="text-center">No data found.</div>;
    }

    return resources?.map((item, key) => (
      <Col className={setClass(key)} style={{ 'padding-left': '0' }} key={item.id}>
        <div className="resourcestab" key={item.id}>
          <Link to={"/resources-details/" + item.slug}>
            <div
              className="resourcestabinnercontent"
              style={{
                backgroundImage: 'url(' + item.image + ')',
              }}
            >
              <div>
                <h3>{item.short_title}</h3>
                <div className="d-flex align-items-center">
                  <div className="resourecimg">
                    <img
                      src={item.user_image}
                      className="img-fluid"
                      alt="business career mentor program"
                    />
                  </div>
                  <div className="resourcecontent">
                    <p className="m-0">
                      {item.user_name}
                      <small className="d-block mt-1">
                        {item.date}
                      </small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </Col>
    ));
  };

  return (
    <div>
      <section className="outer_main">
        <Container className="page_heading text-center">
          <h1 style={{ fontSize: '24px', fontWeight: '600' }}>Resources {title ? ' (' + title + ')' : ''}</h1>
          <div className="d-flex mt-4 justify-content-center align-items-center">
            {setting?.submit_writeup === 1 &&
              <button className="btn btn_login " onClick={(e) => { PostResourceHub(e) }}>
                Submit your write up
              </button>
            }
            {isSectionShow('Subscription') && <SubscribeResource />}
          </div>
        </Container>

        <div className="page_content">
          <Container>
            <div className="linkpart linkresorce">
              <ul style={{ border: 'none', backgroundColor:"white" }}>
                {resoucesDrop.map((item, key) => (
                  <>
                    {(item?.slug === 'all-posts' || item?.slug === 'people-stories' ||
                      item?.slug === 'points-of-view') && getFieldValidation('Resource Hub')?.status === 'Enabled' && getFieldValidationChildren('Resource Hub', 'Resources Hub')?.status === 'Enabled' ?
                      <li key={item.id} className={(item.slug === params) ? 'linkpart-active' : ''} style={{ border: '1px solid #ddd', borderRadius: '8px', margin: '5px' }}><button onClick={(e) => {
                        resoucesPages(e, item.name, item.slug);
                      }} style={{ border: 'none', backgroundColor: 'white' }}>
                        <i className={item.class}></i>
                        <h6>{item.name}</h6></button>
                      </li> : (item?.slug !== 'all-posts' && item?.slug !== 'people-stories' && item?.slug !== 'points-of-view') && <li key={item.id} className={(item.slug === params) ? 'linkpart-active' : ''} style={{ border: '1px solid #ddd', borderRadius: '8px', margin: '5px' }}><button onClick={(e) => {
                        resoucesPages(e, item.name, item.slug);
                      }} style={{ border: 'none', backgroundColor: 'white' }}>
                        <i className={item.class}></i>
                        <h6>{item.name}</h6></button>
                      </li>}
                  </>
                ))}
                {getFieldValidationChildren('Resource Hub', 'Newsletter')?.status === 'Enabled' &&
                  <li style={{ border: '1px solid #ddd', borderRadius: '8px', margin: '5px' }}>
                    <button onClick={(e) => {
                      redirectNewsletter(e);
                    }} style={{ border: 'none', backgroundColor: 'white' }}>
                      <i className="fas fa-envelope-open-text"></i>
                      <h6>Newsletter</h6>
                    </button>
                  </li>}
                {getFieldValidationChildren('Resource Hub', 'Videos')?.status === 'Enabled' && <li style={{ border: '1px solid #ddd', borderRadius: '8px', margin: '5px' }}>
                  <button onClick={(e) => {
                    redirectVideos(e);
                  }} style={{ border: 'none', backgroundColor: 'white' }}>
                    <i className="fas fa-video"></i><h6>Videos</h6>
                  </button>
                </li>}
              </ul>
            </div>
            <div className="page_content_inner removecol_condition p-0">
              <Row>
                {renderResourceContent()}
              </Row>
            </div>
          </Container>
        </div>
      </section>
      <PopupModalWithOk
        show={showPopup}
        onHide={() => {
          setShowPopup(false); // close popup
        }}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />
    </div>
  );
}

Index.propTypes = {
  setting: PropTypes.shape({
    name: PropTypes.string,
    module_data: PropTypes.arrayOf(PropTypes.object),
    submit_writeup: PropTypes.number,
  }).isRequired,
};

export default Index;
